import { OverflowTooltip } from '../../apps/professional-app/fa/common/OverflowTooltip/OverflowTooltip'
import { getUserDisplayName } from '../../apps/professional-app/fa/common/aifeatures/utils'
import { Stack } from 'react-bootstrap'
import React from 'react'
import { useAppSelector } from '../../store/hooks'
import { selectSafeAuthenticatedUser } from '../../store/auth/authSlice'
import { User } from '../../models/User'

export interface MeetingParticipantsDisplayProps {
  creatorId?: string
  users: User[]
  countOnly?: boolean
}

export const MeetingParticipantsDisplay: React.FC<MeetingParticipantsDisplayProps> = ({ creatorId, users, countOnly = false }) => {
  const { id: currentUserId } = useAppSelector(selectSafeAuthenticatedUser)
  const filteredUsers = users.filter((u) => u.id !== creatorId)
  return (
    <Stack className='p-1' direction='horizontal' gap={2}>
      <i className='bi bi-people-fill icon' />
      {countOnly ? (
        <span className='paragraph-small participant-names'>{users.length}</span>
      ) : (
        <OverflowTooltip>
          <span className='paragraph-small participant-names'>
            {`${filteredUsers
              .slice(0, 2)
              .map((u) => (u.id === currentUserId ? 'Me' : getUserDisplayName(u)))
              .join(', ')}${filteredUsers.length > 2 ? ` (+${filteredUsers.length - 2})` : ''}` || '-'}
          </span>
        </OverflowTooltip>
      )}
    </Stack>
  )
}
